import React, { useEffect } from "react";
import ReactPaginate from "react-paginate";
import './pagination.css'; // Import the CSS file

const PaginationComponent = ({ onPageChange, totalItems, pageSize }) => {
  // Calculate the total number of pages
  const pageCount = Math.ceil(totalItems / pageSize);

  // Use effect to set the role attribute when the component mounts or pageCount changes
  useEffect(() => {
    if (pageCount > 1) {
      const timeoutId = setTimeout(() => {
        const ulNode = document.querySelector('.pagination'); // Adjust the selector to target your ul

        if (ulNode) {
          ulNode.setAttribute("role", "list");
        }
      }, 0); // Delay execution until after render

      return () => clearTimeout(timeoutId); // Cleanup timeout
    }
  }, [pageCount]);

  // Determine if pagination with << >> should be displayed
  const showArrows = pageCount > 4;

  if (pageCount <= 1) {
    return null; // Do not display pagination
  }

  return (
    <div>
      <ReactPaginate
        previousLabel={showArrows ? "<<" : ""}
        nextLabel={showArrows ? ">>" : ""}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={showArrows ? 1 : 0}
        pageRangeDisplayed={showArrows ? 3 : pageCount} // Display 3 pages in range when arrows are visible
        onPageChange={onPageChange} // Call the passed function when page changes
        containerClassName={"pagination"}
        activeClassName={"active"}
        pageClassName={"page-item"}
        previousClassName={"previous-item"}
        nextClassName={"next-item"}
        breakClassName={"break-item"}
        disabledClassName={"disabled-item"}
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default PaginationComponent;
